export default "dist/images/block-blockquote-plain.7ee3a2a.png";